import { ArrowLeft, Chrome, Clock3, KeyRound, LogIn, RefreshCcw } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function BantuanLogin() {
  return (
    <div className="min-h-screen bg-[#050914] text-slate-200 flex justify-center p-5" data-testid="bantuan-login-page">
      <div className="w-full max-w-md py-8 space-y-5">
        <div className="text-center space-y-3">
          <div className="inline-block rounded-2xl px-6 py-3 bg-[#040810] border border-white/10 shadow-inner">
            <img src="/logo.png?v=3" alt="Fasnet Fiber" className="h-12 w-auto object-contain mx-auto" />
          </div>
          <h1 className="text-xl font-bold text-white">Bantuan Login</h1>
          <p className="text-xs text-slate-400">Panduan masuk ke sistem Billing Fasnet Fiber untuk agen & mitra.</p>
        </div>

        <div className="bg-[#0A1020] border border-[#1A2644] rounded-2xl p-5 space-y-3" data-testid="help-steps">
          <p className="text-xs font-bold uppercase tracking-wider text-[#F04E23]">Cara Login</p>
          {[
            { icon: LogIn, text: "Buka halaman login, lalu tekan tombol \"Masuk dengan Google\"." },
            { icon: KeyRound, text: "Pilih akun Gmail yang sudah didaftarkan admin, lalu masukkan PIN akun Anda." },
            { icon: Clock3, text: "Selesai — Anda langsung masuk ke dashboard." },
          ].map((s, i) => (
            <div key={i} className="flex items-start gap-3">
              <span className="w-7 h-7 rounded-lg bg-[#F04E23]/15 border border-[#F04E23]/30 flex items-center justify-center shrink-0">
                <s.icon className="w-3.5 h-3.5 text-[#F04E23]" />
              </span>
              <p className="text-sm text-slate-300 leading-relaxed">{i + 1}. {s.text}</p>
            </div>
          ))}
        </div>

        <div className="bg-amber-500/5 border border-amber-500/25 rounded-2xl p-5 space-y-3" data-testid="help-error">
          <p className="text-xs font-bold uppercase tracking-wider text-amber-400">Muncul "Invalid state parameter"?</p>
          <p className="text-sm text-slate-300 leading-relaxed">
            Itu bukan kesalahan akun Anda — hanya sesi login yang kedaluwarsa. Cukup:
          </p>
          <div className="flex items-start gap-3">
            <span className="w-7 h-7 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center shrink-0">
              <RefreshCcw className="w-3.5 h-3.5 text-amber-400" />
            </span>
            <p className="text-sm text-slate-300 leading-relaxed"><b className="text-white">Jangan refresh halaman error itu.</b> Kembali ke halaman login, lalu ulangi "Masuk dengan Google" — biasanya langsung berhasil.</p>
          </div>
          <div className="flex items-start gap-3">
            <span className="w-7 h-7 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center shrink-0">
              <Chrome className="w-3.5 h-3.5 text-amber-400" />
            </span>
            <p className="text-sm text-slate-300 leading-relaxed">Buka link langsung dari browser <b className="text-white">Chrome/Safari</b>, bukan dari dalam WhatsApp. Pastikan tanggal & jam HP disetel otomatis.</p>
          </div>
        </div>

        <div className="bg-[#0A1020] border border-[#1A2644] rounded-2xl p-5 space-y-2" data-testid="help-contact">
          <p className="text-xs font-bold uppercase tracking-wider text-[#F04E23]">Masih Gagal?</p>
          <p className="text-sm text-slate-300 leading-relaxed">Hubungi admin FASNET via WhatsApp <b className="text-white">0898 535 4000</b> — sertakan email Gmail yang Anda pakai agar admin bisa memeriksa akun Anda.</p>
        </div>

        <Link to="/">
          <Button className="w-full h-12 bg-[#F04E23] hover:bg-[#D83E15] text-white font-semibold rounded-xl" data-testid="btn-back-login">
            <ArrowLeft className="w-4 h-4 mr-1.5" /> Kembali ke Halaman Login
          </Button>
        </Link>
        <p className="text-center text-[10px] text-slate-600 font-mono">Fasnet WiFi Billing v2.0</p>
      </div>
    </div>
  );
}
